var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#455079;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}.c{fill:#455079;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1272 -1246)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(1272 1246)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1275 1249)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M5.285,7.929a5.039,5.039,0,1,1,2.8,2.8h0l-.922.922H5.483v1.681H3.8v1.681H1v-2.8L5.285,7.929Z",
    transform: "translate(-1 -1.016)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 1.25,
    cy: 1.25,
    r: 1.25,
    transform: "translate(8.518 2.556)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.6633640161c5d493ccd039036bb0ba55.svg";
export { ForwardRef as ReactComponent };